import { Injectable } from '@angular/core';
import { UAParser } from 'ua-parser-js';

@Injectable({
  providedIn: 'root',
})
export class DeviceDetectionService {
  private readonly device = new UAParser().getResult();

  public isMobile(): boolean {
    const { type } = this.device.device;

    return type === 'mobile' || type === 'tablet';
  }

  public isDesktop(): boolean {
    return !this.isMobile();
  }

  public isIphone(): boolean {
    return this.device.os.name === 'iOS';
  }

  public isAndroid(): boolean {
    return this.device.os.name === 'Android';
  }
}
